import * as React from 'react';
import { useSelector } from 'react-redux';
import { Alert, Card, Spin } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { PublishedVersionsFetchStatus } from 'app/pages/AgentPricing/modules/PublishedVersions/state';
import { getPublishedVersionsFetchStatus, getPublishedAgentCommission } from 'app/pages/AgentPricing/modules/PublishedVersions';
import PublishedVersionsTable from 'app/pages/AgentPricing/components/PublishedVersionsTable';

export interface PublishedVersionsSectionProps {}

const PublishedVersionsSection = (_props: PublishedVersionsSectionProps) => {
    const status = useSelector(getPublishedVersionsFetchStatus);
    const hasVersions = useSelector((state: any) => getPublishedAgentCommission(state).length !== 0);

    switch (status) {
        case PublishedVersionsFetchStatus.Success:
            if (!hasVersions) {
                return (
                    <Card>
                        <Alert
                            title="No published versions"
                            description="This agent does not have any published agent commission."
                            type="info"
                            showIcon
                            icon={<InfoCircleOutlined />}
                        />
                    </Card>
                );
            }

            return <PublishedVersionsTable />;

        case PublishedVersionsFetchStatus.Running:
            return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                    <Spin size="large" />
                </div>
            );

        case PublishedVersionsFetchStatus.Errored:
        default:
            return (
                <Card>
                    <Alert
                        title="Unable to load version history"
                        description="An error occurred when trying to fetch the published versions. Please try again."
                        type="error"
                        showIcon
                    />
                </Card>
            );
    }
};

export default PublishedVersionsSection;
